import { PayloadAction } from 'sos-common/js/commonTypes/action.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { Action } from 'redux';

export const SET_VALIDATION_RESULTS = 'SET_VALIDATION_RESULTS';

export type setValidationResultsAction = PayloadAction<typeof SET_VALIDATION_RESULTS, ValidationResult[]>;

export function setValidationResults(validationResults: ValidationResult[]) {
  return {
    type: SET_VALIDATION_RESULTS,
    payload: validationResults,
  } as setValidationResultsAction;
}

export const DO_VALIDATE = 'DO_VALIDATE';
export type doValidateAction = Action<typeof DO_VALIDATE>;

export function doValidate() {
  return {
    type: DO_VALIDATE,
  } as doValidateAction;
}

export type validationActions = setValidationResultsAction | doValidateAction;
